import React from 'react'

import type { Faq } from '../../../api/companies/types'
import Collapsable from '../layout/Collapsable'
import DescriptionText from '../content/DescriptionText'

type Props = { data: Faq[] }
const Faqs:React.FC<Props> = ({ data }) => {
  if(!data) { return null }
  return (
    data.map((faq) => (
      <div key={faq.question}>
        <Collapsable label={faq.question}>
          <DescriptionText>{faq.answer}</DescriptionText>
        </Collapsable>
      </div>
    ))
  )
}

export default Faqs
